import type { ReactNode } from 'react';
import { Drawer, Modal } from 'antd';
import { useBreakpoint } from '@/shared/lib/hooks';

export interface FormDrawerProps {
  open: boolean;
  title: ReactNode;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  width?: number;
}

/** `Drawer` on mobile, `Modal` on desktop (docs/PLAN.md §6) — every create/edit form uses this. */
export function FormDrawer({
  open,
  title,
  onClose,
  children,
  footer,
  width = 520,
}: FormDrawerProps) {
  const { isMobile } = useBreakpoint();

  if (isMobile) {
    return (
      <Drawer
        open={open}
        title={title}
        onClose={onClose}
        placement="bottom"
        height="90vh"
        footer={footer}
      >
        {children}
      </Drawer>
    );
  }

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onClose}
      footer={footer}
      width={width}
      destroyOnHidden
    >
      {children}
    </Modal>
  );
}
